import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';

const EmptyPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>{t('Page Not Found')}</h1>
      <p>{t('The page you are looking for does not exist.')}</p>
      <Button
        style={{ margin: 'auto' }}
        title={t('Go back')}
        onClick={() => history.goBack()}
      />
    </div>
  );
};

export default EmptyPage;
